import { ethers } from "ethers";
import handleError from "./handleError";

async function writeContract(
  setTxStatus,
  setPopupData,
  userData,
  func,
  contractName,
  id
) {
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const signer = provider.getSigner();
  var contract;
  var ids = [id];

  if (contractName === "oldContract")
    contract = new ethers.Contract(
      process.env.REACT_APP_STAKING_ADDRESS_OLD,
      process.env.REACT_APP_STAKING_ABI_OLD,
      provider
    );
  else if (contractName === "newContract")
    contract = new ethers.Contract(
      process.env.REACT_APP_STAKING_ADDRESS,
      process.env.REACT_APP_STAKING_ABI,
      provider
    );
  else if (contractName === "lpContract")
    return writeLpContract(provider, signer, func, id);

  const contractWithSigner = contract.connect(signer);

  if (id === null) {
    if (contractName === "newContract") {
      ids = userData.dataNew.map((element) => element.id);
    } else ids = userData.stakesOld;
  }

  if (func === "stake") {
    ids = ids[0].split(",");
    ids.forEach((element, index) => {
      if (element.includes(" ")) {
        ids[index] = element.replace(" ", "");
        console.log(ids);
      }
    });

    console.log(ids);
  }

  toggleButtons();

  contractWithSigner[func](ids.filter((x) => x !== "lp"))
    .then(async (tx) => {
      handleTx(tx, setPopupData, setTxStatus);
    })
    .catch((err) => {
      handleErr(err, setPopupData, setTxStatus);
    });
}

function writeLpContract(
  setTxStatus,
  setPopupData,
  provider,
  signer,
  func,
  id
) {
  const contract = new ethers.Contract(
    process.env.REACT_APP_LP_STAKING_ADDRESS,
    process.env.REACT_APP_LP_STAKING_ABI,
    provider
  );
  const contractWithSigner = contract.connect(signer);

  toggleButtons();

  contractWithSigner[func](id && String(id * 10 ** 18))
    .then(async (tx) => {
      handleTx(tx, setPopupData, setTxStatus);
    })
    .catch((err) => {
      handleErr(err, setPopupData, setTxStatus);
    });
}

/* ////////// */

async function handleTx(tx, setPopupData, setTxStatus) {
  console.log(setTxStatus);
  setTxStatus("pending");
  await tx.wait();
  toggleButtons();
  setTxStatus("none");
  setPopupData({
    show: true,
    color: "#10780b",
    message: "Your transaction was successful.",
  });
  // TODO: Refresh user data
}

function handleErr(err, setPopupData, setTxStatus) {
  console.log(err);
  toggleButtons();
  const errData = handleError(err);
  setPopupData({ show: true, color: "#ba1e1e", message: errData.message });
}

function toggleButtons() {
  const buttons = document.querySelectorAll("button");
  buttons.forEach((button) => {
    if (button.hasAttribute("disabled")) button.removeAttribute("disabled");
    else button.setAttribute("disabled", "true");
  });
}

export { writeContract, handleTx, handleErr, toggleButtons };
